import { ReactElement, ReactNode } from "react";
import { Flex, Stack, Text, useMantineTheme } from "@mantine/core";
import { useStyles } from "./MeteredAddOnUsage.styled";

interface IUsageListingProps {
  dataTestId: string;
  periodLabel: string;
  rowLabel: string;
  value: number;
  children?: ReactNode;
}

/** the leader-dotted "what was used" row shared by the free and paid variants */
export function UsageListing({
  dataTestId,
  periodLabel,
  rowLabel,
  value,
  children,
}: IUsageListingProps): ReactElement {
  const { spacing } = useMantineTheme();
  const { classes } = useStyles();

  return (
    <Stack data-testid={dataTestId} spacing="xs" mt={spacing.sm}>
      <Text c="gray.4" fz="sm">
        {periodLabel}
      </Text>

      <Flex
        align="baseline"
        direction="row"
        gap="xs"
        justify="flex-start"
        wrap="nowrap"
        w="100%"
      >
        <Text>{rowLabel}</Text>
        <Flex className={classes.dots} opacity={0.2} />
        <Text>{value.toLocaleString("en-US")}</Text>
      </Flex>

      {children}
    </Stack>
  );
}
